import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { callApi } from "../../ApiHelper/ApiHelper";
import { apiUrl } from "../../ApiHelper/ApiUrl";

const ReqDeactivateForm = () => {
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
    setValue,
  } = useForm();

  const [loading, setLoading] = useState(false);

  const onSubmit = (data) => {
    setLoading(true);

    const postData = {
      ...data,
      requestType: "deactivate-account",
    };

    callApi(apiUrl.request_deactivate, {
      method: "POST",
      data: postData,
    }).then((response) => {
      setLoading(false);
      if (response?.status) {
        toast.success(response?.message);
        reset();
      } else {
        toast.error(response?.message);
      }
    });
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      {/* Name */}
      <div className="form-group mb-4">
        <label htmlFor="name">
          Name <span className="text-danger">*</span>
        </label>
        <input
          className={`form-control ${errors.name ? "is-invalid" : ""}`}
          id="name"
          type="text"
          placeholder="Enter your name"
          {...register("name", {
            required: "Name is required",
          })}
        />
        {errors.name && (
          <small className="text-danger">{errors.name.message}</small>
        )}
      </div>

      {/* Phone */}
      <div className="form-group mb-4">
        <label htmlFor="phone">
          Phone Number<span className="text-danger">*</span>
        </label>
        <input
          className={`form-control ${errors.phone ? "is-invalid" : ""}`}
          id="phone"
          type="text"
          placeholder="Enter phone number"
          {...register("phone", {
            required: "Phone number is required",
            minLength: {
              value: 10,
              message: "Phone number must be 10 digits",
            },
          })}
          onChange={(e) => {
            const onlyNumbers = e.target.value.replace(/[^0-9]/g, "");
            setValue("phone", onlyNumbers, { shouldValidate: true });
          }}
        />
        {errors.phone && (
          <small className="text-danger">{errors.phone.message}</small>
        )}
      </div>

      {/* Reason */}
      <div className="form-group mb-4">
        <label htmlFor="reason">
          Reason <span className="text-danger">*</span>
        </label>
        <textarea
          className={`form-control ${errors.reason ? "is-invalid" : ""}`}
          id="reason"
          rows={3}
          placeholder="Enter reason"
          {...register("reason", {
            required: "Reason is required",
          })}
        />
        {errors.reason && (
          <small className="text-danger">{errors.reason.message}</small>
        )}
      </div>

      {/* Submit Button */}
      <button className="btn puprple_btn" type="submit" disabled={loading}>
        {loading ? (
          <div className="spinner-border" role="status">
            <span className="sr-only">Loading...</span>
          </div>
        ) : (
          "Submit Request"
        )}
      </button>
    </form>
  );
};

export default ReqDeactivateForm;
